import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'upsc-gauge',
    templateUrl: './gauge.component.html',
    styleUrls: ['./gauge.component.scss'],
})
export class GaugeComponent implements OnInit {
    @Input() public value = 0;
    @Input() public color = '#0A8080';
    @Input() public shouldShowMarker = true;
    @Input() public markerPosition: 'top' | 'bottom' = 'top';
    @Input() public enableAnimation = true;

    @HostBinding('class') public hostClass = 'gauge';

    public progressWidth$ = new BehaviorSubject<string>('0%');

    constructor() {
    }

    public get progressWidth() {
        if (this.value <= 0) {
            return `0`;
        }

        if (this.value >= 100) {
            return `100%`;
        }

        return `${ this.value }%`;
    }

    public ngOnInit() {
        /**
         * WARN: Do not set delay to 0. It will create an infinite loop:
         *  1. progressWidth$.pipe(delay(0)) subscribes immediately.
         *  2. `this.progressWidth$.next(this.progressWidth);` called in that subscription immediately emits to any subscription.
         *  3. This consequently triggers the subscription again.
         *  --> infinite loop!
         */
        this.progressWidth$.pipe(delay(10))
            .subscribe(() => {
                this.progressWidth$.next(this.progressWidth);
            });
    }
}
